<template>
  <div>
    <v-tooltip top>
      <template #activator="{ on }">
        <v-chip class="pl-1" :color="color" v-on="on">
          <v-chip class="px-1 mr-2" color="white" small>
            <v-icon :color="color" small>trending_up</v-icon>
          </v-chip>
          <span class="percentage text-right white--text">
            <template v-if="hasStats">{{ percentage }}%</template>
          </span>
        </v-chip>
      </template>
      <span>
        <template v-if="hasStats">Link has {{ percentage }}% uptime</template>
        <template v-else>No uptime recorded</template>
      </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'UptimePercntage',
  props: {
    stats: {
      type: Object,
      required: true,
    },
  },
  computed: {
    color() {
      if (!this.hasStats) return 'grey lighten-2'
      if (this.percentage >= 100) return 'success'
      if (this.percentage >= 75) return 'yellow darken-2'
      if (this.percentage >= 50) return 'warning'
      return 'error'
    },
    percentage() {
      const { errors, total } = this.stats
      if (!total) return
      const good = total - errors
      return Math.round((good / total) * 100)
    },
    hasStats() {
      return this.percentage !== undefined
    },
  },
}
</script>

<style lang="scss" scoped>
.percentage {
  width: 35px;
}
</style>
